import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "DistributorName",
  "use": "DistributorName-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol class=\"fizz-icon-16\" viewBox=\"0 0 32 32\" id=\"DistributorName\">\n  <path d=\"M16 9V3.4H2v25.2h28V9H16zM7.6 25.8H4.8V23h2.8v2.8zm0-5.6H4.8v-2.8h2.8v2.8zm0-5.6H4.8v-2.8h2.8v2.8zm0-5.6H4.8V6.2h2.8V9zm5.6 16.8h-2.8V23h2.8v2.8zm0-5.6h-2.8v-2.8h2.8v2.8zm0-5.6h-2.8v-2.8h2.8v2.8zm0-5.6h-2.8V6.2h2.8V9zm14 16.8H16V23h2.8v-2.8H16v-2.8h2.8v-2.8H16v-2.8h11.2v14zm-2.8-11.2h-2.8v2.8h2.8v-2.8zm0 5.6h-2.8V23h2.8v-2.8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol